import React from 'react';
import { ImportMetadata } from '../types';

interface ImportFormHeaderProps {
  metadata: ImportMetadata;
  modifiedFields: Set<string>;
  onUpdate: (field: keyof ImportMetadata, value: string) => void;
}

const fields: { key: keyof ImportMetadata; label: string; type?: string }[] = [
  { key: 'reference', label: 'Référence' },
  { key: 'fournisseur', label: 'Fournisseur' },
  { key: 'dateDevis', label: 'Date', type: 'date' },
  { key: 'client', label: 'Client' },
  { key: 'chantier', label: 'Chantier' },
  { key: 'lotOuCorps', label: 'Lot / Corps' },
];

const ImportFormHeader: React.FC<ImportFormHeaderProps> = ({ metadata, modifiedFields, onUpdate }) => {
  return (
    <div className="grid grid-cols-3 gap-x-4 gap-y-2 px-3 py-3 bg-gray-50 rounded-lg border border-gray-100">
      {fields.map(({ key, label, type }) => {
        const modified = modifiedFields.has(`meta:${key}`);
        return (
          <div key={key} className="flex flex-col">
            <label className="text-xs text-gray-500 mb-0.5">{label}</label>
            <input
              type={type || 'text'}
              value={metadata[key]}
              onChange={(e) => onUpdate(key, e.target.value)}
              className={`text-sm bg-white border rounded px-2 py-1 focus:border-violet-400 focus:ring-1 focus:ring-violet-200 outline-none ${
                modified ? 'border-violet-300' : 'border-gray-200'
              }`}
            />
          </div>
        );
      })}
    </div>
  );
};

export default ImportFormHeader;
